





























































































































































































































import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import moment from "moment";
import store from "@/store";
// @types
import { VesselEvent } from "@/types/vesselEvent";
// @modules
import { getModule } from "vuex-module-decorators";
import VesselEventsModule from "@/store/clients/VesselEvents.module";

const VesselEvents = getModule(VesselEventsModule, store);

@Component({})
export default class DateRangeEventsDatepicker extends Vue {
  @Prop({ default: null }) value!: [string, string] | null;

  // @Data
  localDateRange: [string | null, string | null] | null = null;
  previousLocalDateRange: [string, string] | null = null;
  eventClickCount = 0;
  dataRangeMaskStart = "";
  dataRangeMaskEnd = "";
  DateRangeEventsSelectMenuIsOpen = false;
  formatDate = {
    stringify: (date: Date | string) => {
      if (!date) return "";
      // If already a string in YYYY-MM-DD, just return it
      if (typeof date === "string" && moment(date, "YYYY-MM-DD", true).isValid()) {
        return date;
      }
      // Otherwise, try to format as date
      const m = moment(date);
      return m.isValid() ? m.format("YYYY-MM-DD") : "";
    },
    parse: (value: string) => {
      return value ? moment(value, "YYYY-MM-DDTHH:mm").toDate() : null;
    },
  };

  // @Watchers
  @Watch("value", { immediate: true, deep: true })
  onValueChange(newVal: [string, string] | null) {
    this.localDateRange = Array.isArray(newVal) ? [...newVal] : null;
  }

  // @Getters
  get formattedDateRange(): string {
    const val = this.value || [];
    const [start, end] = val;

    const startStr = start && moment.utc(start).isValid() ? moment.utc(start).format("D MMM YYYY") : "";
    const endStr = end && moment.utc(end).isValid() ? moment.utc(end).format("D MMM YYYY") : "";

    if (startStr && endStr) return `${startStr} - ${endStr}`;
    if (startStr) return startStr;
    if (endStr) return endStr;
    return "";
  }

  get isRangeTooLarge(): boolean {
    if (!this.localDateRange || !this.localDateRange[0] || !this.localDateRange[1]) return false;
    const start = moment.utc(this.localDateRange[0]);
    const end = moment.utc(this.localDateRange[1]);
    return end.diff(start, "years", true) > 5;
  }

  get formattedMaskStart(): string {
    return this.localDateRange && this.localDateRange[0] ? moment(this.localDateRange[0]).format("D MMM YYYY") : "";
  }
  get formattedMaskEnd(): string {
    return this.localDateRange && this.localDateRange[1] ? moment(this.localDateRange[1]).format("D MMM YYYY") : "";
  }

  get vesselTrendEvents(): VesselEvent[] {
    return [...VesselEvents.trendEvents].sort((a, b) => moment.utc(b.timestamp).valueOf() - moment.utc(a.timestamp).valueOf());
  }

  // @Methods
  onEventItemClick(eventTimestamp: string) {
    const date = moment.utc(eventTimestamp).format("YYYY-MM-DD");
    // If starting new selection or both dates are set, start with [date, ""]
    if (!this.localDateRange || (this.localDateRange[0] && this.localDateRange[1])) {
      this.localDateRange = [date, ""];
      this.localDateRange = [...this.localDateRange]; // force reactivity
      this.eventClickCount = 1;
      this.$nextTick(() => {
        const dp = this.$refs.DatePicker as any;
        if (dp && typeof dp.$forceUpdate === "function") {
          dp.$forceUpdate();
        }
      });
    } else if (this.localDateRange[0] && !this.localDateRange[1]) {
      // Second click: set end, sort
      const [firstDate] = this.localDateRange;
      const dates = [firstDate, date].sort();
      this.localDateRange = [dates[0], dates[1]];
      this.localDateRange = [...this.localDateRange];
      this.eventClickCount = 0;
    }
  }

  onEventMenuSelect(eventTimestamp: string, option: string) {
    const eventDate = moment.utc(eventTimestamp);
    let start: string, end: string;

    switch (option) {
      case "only":
        // Select event date only (single date, clear end)
        this.localDateRange = [eventDate.format("YYYY-MM-DD"), ""];
        break;
      case "3m-before":
        start = eventDate.clone().subtract(3, "months").format("YYYY-MM-DD");
        end = eventDate.format("YYYY-MM-DD");
        this.localDateRange = [start, end];
        break;
      case "3m-after":
        start = eventDate.format("YYYY-MM-DD");
        end = eventDate.clone().add(3, "months").format("YYYY-MM-DD");
        this.localDateRange = [start, end];
        break;
      case "6m-before":
        start = eventDate.clone().subtract(6, "months").format("YYYY-MM-DD");
        end = eventDate.format("YYYY-MM-DD");
        this.localDateRange = [start, end];
        break;
      case "6m-after":
        start = eventDate.format("YYYY-MM-DD");
        end = eventDate.clone().add(6, "months").format("YYYY-MM-DD");
        this.localDateRange = [start, end];
        break;
    }
    // Force reactivity
    this.localDateRange = this.localDateRange ? [...this.localDateRange] : null;
    this.eventClickCount = 0;
  }

  formatEventDate(date: string): string {
    return moment.utc(date).format("D MMM YYYY");
  }

  disableFutureDates(date: Date) {
    // Disable if date is after today
    return date > new Date();
  }

  applyDateRangeChange() {
    this.$emit("input", this.localDateRange ? [...this.localDateRange] : null);
    this.DateRangeEventsSelectMenuIsOpen = false;
    this.eventClickCount = 0;
  }

  cancelDateRangeChange() {
    this.localDateRange = this.value ? [...this.value] : null;
    this.DateRangeEventsSelectMenuIsOpen = false;
    this.eventClickCount = 0;
  }
}
